// extracted by mini-css-extract-plugin
module.exports = {"title":"_500_title_2E_cv"};